module.exports = __webpack_public_path__ + "img/carscience-logo-light.d0af9e66.svg";